<template>
    <div v-if="searchResults.length > 0">
        <div class="mt-3 sans text-muted">
            <slot name="search-results-found-label"></slot>
        </div>

        <accordion class="mt-4">
            <div v-for="(searchResult, index) in searchResults" :key="index">
                <search-result-card :search-result="searchResult" :results-per-card=resultsPerCard :query=query :locale="locale"></search-result-card>
            </div>
        </accordion>
    </div>
    <div v-else>
        <div class="mt-3 sans">
            <slot name="no-results-found-label">No results were found.</slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            query: { type: String, required: true },
            searchResults: { type: Array, required: true },
            resultsPerCard: { type: Number, required: false, default: 5 },
            locale: { type: String, required: true }
        }
    }
</script>